import { toRaw } from 'vue';
import { FormValidator, isEmpty, type FormValidatorConfig, type FormValidatorContext, type FormValidatorSettings } from '@common/index';
import { getStrippedValue } from '@common/lib/modules/form/utils/validartor.utils';

export interface SampleUnitOneOfRequiredValidatorSettings extends FormValidatorSettings {
  stripTags?: boolean;
}

export type SampleUnitOneOfRequiredValidatorConfig = FormValidatorConfig<SampleUnitOneOfRequiredValidatorSettings>;

export class SampleUnitOneOfRequiredValidator extends FormValidator<SampleUnitOneOfRequiredValidatorSettings> {
  constructor() {
    super();
    this._name = 'sampleUnitOneOfRequired';
    this._settings = {
      invalidMessage: 'sampleUnit.validation.sampleUnitOneOfRequired',
      needTranslate: true,
      stripTags: false
    };
  }

  public override async onValidate(_: any, context: FormValidatorContext) {
    const formValues = toRaw(context.element.form?.value);
    const fields = ['ownCurriculum', 'notes', 'requiredReading', 'recommendedReading'];

    if (!formValues) {
      this.reset();
      return;
    }

    this.valid = fields.some((field) => {
      const value = this._settings.stripTags ? getStrippedValue(formValues[field]) : formValues[field];

      return !!value && !isEmpty(value);
    });

    if (!this.valid) {
      this.addMessage(this.settings.invalidMessage);
    }
  }
}
